"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ConversationMode;
(function (ConversationMode) {
    ConversationMode[ConversationMode["LiveChat"] = 192350000] = "LiveChat";
    ConversationMode[ConversationMode["PersistentChat"] = 192350001] = "PersistentChat";
})(ConversationMode || (ConversationMode = {}));
exports.default = ConversationMode;
//# sourceMappingURL=ConversationMode.js.map